<template>
  <button
    v-if="!isProd"
    class="debug-toggle"
    :class="{ 'debug-toggle--on': enabled }"
    @click="toggle"
    title="Toggle debug inspector"
  >
    🐛
  </button>
</template>

<script>
import CommonHelper from "@/helpers/common.helper.js";
import { debugState, toggleDebug } from "@/helpers/debug.state.js";

export default {
  name: "DebugToggle",
  computed: {
    isProd() {
      return CommonHelper.isProd();
    },
    enabled() {
      return debugState.enabled;
    }
  },
  methods: {
    toggle() {
      toggleDebug();
    }
  }
};
</script>

<style lang="scss">
.debug-toggle {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 99999;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #45475a;
  background: #1e1e2e;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.35;
  transition:
    opacity 0.15s,
    border-color 0.15s;

  &:hover {
    opacity: 0.9;
  }

  &--on {
    opacity: 1;
    border-color: #fab387;
    box-shadow: 0 0 8px rgba(250, 179, 135, 0.5);
  }
}
</style>
